import React, { useEffect, useState } from 'react';
import { Alert, Button, Select, Space, Upload, UploadProps, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useAppSelector } from '../../../app/hooks';
import { useGetSellersQuery } from '../../../app/api/userApiSlice';

const Text = Typography.Text;
interface IProps {
  onSuccessfulSubmit: () => void;
  drawerVisible: boolean;
}

const ImportVehicleForm: React.FC<IProps> = ({ onSuccessfulSubmit, drawerVisible }: IProps) => {
  const token = useAppSelector((state) => state.auth.token);

  const { data: sellers } = useGetSellersQuery();

  const [message, setMessage] = useState<string>();
  const [errors, setErrors] = useState<string[]>();
  const [sellerId, setSellerId] = useState<string>();

  const props: UploadProps = {
    name: 'file',
    listType: 'picture',
    maxCount: 1,
    multiple: false,
    action: `${process.env.REACT_APP_AUTOSTREAM_API ?? ''}/vehicles/csv/${sellerId ?? ''}`,
    headers: {
      authorization: `Bearer ${token ?? ''}`,
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        setMessage(`${info.file.name} file uploaded successfully`);
        setErrors([]);
      } else if (info.file.status === 'error') {
        setMessage('');
        setErrors(info.file.response?.errors);
      }
    },
    onRemove() {
      setErrors([]);
    },
  };

  useEffect(() => {
    if (!drawerVisible) {
      setMessage('');
      setErrors([]);
    }
  }, [drawerVisible]);

  const handleChange = (value: string): void => {
    setSellerId(value);
  };

  return (
    <>
      <Space direction='vertical'>
        <Select
          style={{ width: '100%' }}
          showSearch
          placeholder='Seller'
          optionFilterProp='children'
          onChange={handleChange}
          filterOption={(input, option) =>
            (option?.label?.toString().toLocaleLowerCase() ?? '').includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label?.toString() ?? '')
              .toLowerCase()
              .localeCompare((optionB?.label?.toString() ?? '').toLowerCase())
          }
          options={sellers?.map((seller) => ({
            value: seller.id,
            label: seller.personInCharge,
          }))}
        ></Select>

        <Upload
          {...props}
          onRemove={() => {
            setErrors([]);
          }}
        >
          <Button icon={<UploadOutlined />} disabled={!sellerId}>
            Click to Upload
          </Button>
        </Upload>
        {message && (
          <>
            <Alert type='success' message={message} />
            <Button type='primary' onClick={onSuccessfulSubmit}>
              Go back to vehicle list
            </Button>
          </>
        )}
        <>
          {errors &&
            errors?.length > 0 &&
            errors?.map((error: any, index) => (
              <Text key={index} type='danger'>
                {error.errorMessage}
              </Text>
            ))}
        </>
      </Space>
    </>
  );
};

export default ImportVehicleForm;
